import { Button, Modal } from 'src/components';
import { defineMessages, useIntl } from 'react-intl';
import Image from 'next/image';
import levelPointsBg from 'images/level-points-graphic.png';
import * as S from './styles';

const msgs = defineMessages({
  ok: {
    id: 'migration_yourprogress_bottomsheet2_cta',
  },
  title: {
    id: 'onboarding_coreLoopUsersToProgress_pointsAndLevels_title',
  },
  paragraphOne: {
    id: 'onboarding_coreLoopUsersToProgress_pointsAndLevels_description1',
  },
  paragraphTwo: {
    id: 'onboarding_coreLoopUsersToProgress_pointsAndLevels_description2',
  },
});

interface MyProgressIntroModalProps {
  isOpen: boolean;
  onClose: () => void;
  progressIndicator?: string;
}

const MyProgressIntroModal = ({
  isOpen,
  onClose,
  progressIndicator,
}: MyProgressIntroModalProps) => {
  const intl = useIntl();

  return (
    <Modal darkCloseIcon isOpen={isOpen} handleClose={onClose}>
      <S.ModalContent>
        <S.ImageContainer>
          <Image alt={intl.formatMessage(msgs.title)} src={levelPointsBg} objectFit="cover" fill />
        </S.ImageContainer>
        <S.Title>{intl.formatMessage(msgs.title)}</S.Title>
        <S.Description>
          <S.Paragraph>{intl.formatMessage(msgs.paragraphOne)}</S.Paragraph>
          <S.Paragraph>{intl.formatMessage(msgs.paragraphTwo)}</S.Paragraph>
        </S.Description>
        <S.ActionButton>
          <Button
            buttonSize="medium"
            buttonType="primary"
            wide
            onClick={onClose}
            data-testid="tooltip_ok_btn"
          >
            {intl.formatMessage(msgs.ok)}
          </Button>
        </S.ActionButton>
        {progressIndicator && <S.ProgressIndicator>{progressIndicator}</S.ProgressIndicator>}
      </S.ModalContent>
    </Modal>
  );
};

export default MyProgressIntroModal;
